import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import ResearchSnapshotTable from "./ResearchSnapshotTable";

const StyledContainer = styled("div")({
    minHeight: "100px",
    border: "1px solid #dbdbdb",
    padding: "15px",
});

const StyledButtons = styled("div")({
    alignSelf: "center",
    marginRight: "20px",
});

const ResearchSnapshot = (props) => {
    const { role, snapshot, editResponse } = props;
    return (
        <StyledContainer>
            <Grid
                container
                spacing={1}
                style={{ marginBottom: "10px" }}
                sx={{
                    justifyContent: "flex-end",
                    alignItems: "center"
                }}>
                <Grid>
                    <StyledButtons></StyledButtons>
                </Grid>
            </Grid>
            <Divider />
            <ResearchSnapshotTable editResponse={editResponse} snapshots={snapshot} role={role} />
        </StyledContainer>
    );
};

export default ResearchSnapshot;
